import Div from "@jumbo/shared/Div";
import {
  Typography,
  Box,
  Tab,
  Table,
  TableBody,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Grid,
} from "@mui/material";
import React from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { format } from "date-fns";
import { CellNoborder, TableRowNoborder } from "app/pages/TableStyled";
import {
  DateFormatter,
  formatIndianNumber,
} from "app/shared/ReuseComponents/DateFormatter";
import { MdClose } from "react-icons/md";
import HistoryOverview from "app/shared/ReuseComponents/HistoryOverview";
import WorkflowApproverStatus from "app/shared/ReuseComponents/WorkflowApproverStatus";
import SingleAttachment from "../EmployeeClaims/SingleAttachment";
import { BASE_URL } from "app/services/auth-services";

const ClaimDocumentApproval = ({
  openViewRequest,
  setOpenViewRequest,
  value,
  handleChange,
  requests,
  approvalStatus,
  updateHistory,
  dateFormat,
}) => {
  const token = localStorage.getItem("accesstoken");
  const header = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  let userDetails = localStorage.getItem("UserDetails");
  userDetails = JSON.parse(userDetails);
  let companyId = userDetails && userDetails.Organization_Id;
  const headApproverName = localStorage.getItem("ReportHeadName");
  const partnerId = parseInt(localStorage.getItem("PartnerId"));
  const WorkflowName = "Reimbursement";

  return (
    <>
      <Dialog maxWidth="lg" fullWidth open={openViewRequest}>
        <DialogTitle
          sx={{ display: "flex", justifyContent: "space-between", mb: -2 }}
        >
          <Div sx={{ fontSize: "18px" }}>Reimbursement Overview</Div>
          <IconButton onClick={() => setOpenViewRequest(false)}>
            <MdClose />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 0, borderColor: "divider" }}>
              <TabList onChange={handleChange} aria-label="tabs">
                <Tab
                  label="Overview"
                  value="1"
                  sx={{ fontSize: "16px", color: "#000000" }}
                />
                {/* <Tab label="History" value="2" sx={{ fontSize: "16px", color: "#000000" }} /> */}
              </TabList>
            </Box>

            {/* ========== Overview Panel ========== */}
            <TabPanel value="1" sx={{ p: 1.5 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography variant="h5">Created Date</Typography>
                  <Typography variant="h5">Claim No</Typography>
                  <Typography variant="h5">Claim Date</Typography>
                  <Typography variant="h5">Reimbursement Type</Typography>
                  <Typography variant="h5">Reimbursement Details</Typography>
                  <Typography variant="h5">Month</Typography>
                  <Typography variant="h5">Eligible Amount</Typography>
                  <Typography variant="h5">Initiated Claim Amount</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Typography variant="h5">
                    :
                    {/* {dateFormat && requests?.Created_Date && format(new Date(requests?.Created_Date), dateFormat)} */}{" "}
                    <DateFormatter date={requests?.Created_Date} />
                  </Typography>
                  <Typography variant="h5">
                    : {requests?.Employeeclaim_Id}
                  </Typography>
                  <Typography variant="h5">
                    :{" "}
                    {requests?.Claim_Date ? (
                      <DateFormatter date={requests?.Claim_Date} />
                    ) : (
                      "-"
                    )}
                  </Typography>
                  <Typography variant="h5">
                    : {requests?.Reimbursement_Type}
                  </Typography>
                  <Typography variant="h5">
                    : {requests?.Bill_Details || "-"}
                  </Typography>
                  <Typography variant="h5">: {requests?.Month}</Typography>
                  <Typography variant="h5">
                    :{" "}
                    {formatIndianNumber(
                      requests?.Reimbursement_Id?.Eligible_Amount,
                    )}
                  </Typography>
                  <Typography variant="h5">
                    : {formatIndianNumber(requests?.Claim_Amount)}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  <Box>
                    {requests?.Approved_Flag === true &&
                    requests?.Status === true ? (
                      <img
                        src="./../../../../../images/StatusFlg/Approved.png"
                        width={150}
                        height={70}
                        alt="Approved"
                      />
                    ) : requests?.Approved_Flag === false &&
                      requests?.Status === true ? (
                      <img
                        src="./../../../../../images/StatusFlg/Rejected.png"
                        width={150}
                        height={70}
                        alt="Rejected"
                      />
                    ) : (
                      <img
                        src="./../../../../../images/StatusFlg/Pending.png"
                        width={150}
                        height={70}
                        alt="Pending"
                      />
                    )}
                  </Box>
                </Grid>
              </Grid>

              {/* for mobile responsive */}
              <Div
                id="no-more-tables"
                sx={{ display: { xs: "block", md: "none" } }}
              >
                <Table
                  className="table table-bordered"
                  sx={{
                    width: "100% !important",
                    mt: 0.5,
                    border: "none !important",
                  }}
                >
                  <TableBody>
                    <TableRowNoborder>
                      <CellNoborder data-title="Date">
                        {dateFormat &&
                          requests?.Created_Date &&
                          format(new Date(requests?.Created_Date), dateFormat)}
                      </CellNoborder>
                      <CellNoborder data-title="Claim No">
                        {requests?.Employeeclaim_Id}
                      </CellNoborder>
                      <CellNoborder data-title="Reimbursement Type">
                        {requests?.Reimbursement_Type}
                      </CellNoborder>
                      <CellNoborder data-title="Month">
                        {requests?.Month}
                      </CellNoborder>
                      <CellNoborder data-title="Eligible Amount">
                        {formatIndianNumber(
                          requests?.Reimbursement_Id?.Eligible_Amount,
                        )}
                      </CellNoborder>
                    </TableRowNoborder>
                  </TableBody>
                </Table>
              </Div>

              <Grid item xs={12} md={12} sx={{ mt: 3 }}>
                <Box
                  sx={{
                    border: "1px solid #e5e7eb",
                    borderRadius: "6px",
                    p: 2,
                    backgroundColor: "#fafafa",
                    // maxWidth: 520,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: "16px",
                      color: "#111827",
                    }}
                  >
                    Attachments
                  </Typography>

                  {requests?.Claim_Attachment ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: 1.2,
                      }}
                    >
                      <SingleAttachment
                        file={requests?.Claim_Attachment}
                        fileSize={requests?.Claim_Attachment_Size} // optional
                        BASE_URL={BASE_URL}
                      />
                    </Box>
                  ) : (
                    <Typography color="text.secondary" fontSize="14px">
                      No documents attached
                    </Typography>
                  )}
                </Box>
              </Grid>

              <Box mt={3}>
                <WorkflowApproverStatus
                  WorkflowName={WorkflowName}
                  partnerId={partnerId}
                  approvalStatus={approvalStatus?.Approve}
                  HeadApproverName={headApproverName}
                />
              </Box>
            </TabPanel>

            {/* ========== History Panel ========== */}
            <TabPanel value="2">
              <HistoryOverview
                updatedHistory={updateHistory}
                itemId="Claim No"
              />
            </TabPanel>
          </TabContext>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ClaimDocumentApproval;
